export enum LinkTypeEnum {
    URL = 'URL',
    EMAIL = 'EMAIL',
    ANCHOR = 'ANCHOR'
}
